import { useState } from 'react';
import DealModal from './DealModal';

export default function DealCard({ deal, type = 'phone' }) {
  const [open, setOpen] = useState(false);

  const {
    name, brand, storage, image, badge,
    package: pkg, data, minutes, onceOff, speed,
    price, wasPrice, save, term, prepaid,
    note, features,
  } = deal;

  const displayName = storage ? `${name} ${storage}` : name;

  return (
    <>
      <div className="deal-card">
        {/* Image area */}
        <div className="deal-card__image">
          {image
            ? <img src={image} alt={name} loading="lazy" />
            : (
              <div className="deal-card__placeholder">
                <span className="deal-card__placeholder-icon">□</span>
                <span className="deal-card__placeholder-text">Add image URL in<br /><code>src/data/{type}.js</code></span>
              </div>
            )
          }
          {badge && <img className="deal-card__badge" src={badge} alt="" />}
        </div>

        {/* Content */}
        <div className="deal-card__body">
          {brand && <span className="deal-card__brand">{brand}</span>}
          <h3 className="deal-card__name">{displayName}</h3>

          {pkg && <p className="deal-card__package">{pkg}</p>}

          <div className="deal-card__specs">
            {data     && <span className="deal-card__spec"><em>Data</em>{data}</span>}
            {speed    && <span className="deal-card__spec"><em>Speed</em>{speed}</span>}
            {minutes  && <span className="deal-card__spec"><em>Min</em>{minutes}</span>}
            {onceOff  && <span className="deal-card__spec"><em>Once-off</em>{onceOff}</span>}
          </div>

          {note && <p className="deal-card__note">{note}</p>}

          {features && (
            <ul className="deal-card__features">
              {features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          )}
        </div>

        {/* Pricing footer */}
        <div className="deal-card__footer">
          {price != null ? (
            <div className="deal-card__price-block">
              <div className="deal-card__price">
                R{price.toLocaleString()}
                {term && <span> pm</span>}
              </div>
              {wasPrice && <div className="deal-card__was">was R{wasPrice.toLocaleString()}/pm</div>}
              {save     && <div className="deal-card__save">SAVE R{save.toLocaleString()}</div>}
              {term     && <div className="deal-card__term">×{term} months</div>}
              {prepaid != null && <div className="deal-card__prepaid">or R{prepaid.toLocaleString()} once-off</div>}
            </div>
          ) : prepaid != null ? (
            <div className="deal-card__price-block">
              <div className="deal-card__price">R{prepaid.toLocaleString()}</div>
              <div className="deal-card__term">once-off</div>
            </div>
          ) : (
            <div className="deal-card__price-block">
              <div className="deal-card__price">Enquire</div>
            </div>
          )}

          <button className="deal-card__cta" onClick={() => setOpen(true)}>View Deal</button>
        </div>
      </div>

      {open && <DealModal deal={deal} type={type} onClose={() => setOpen(false)} />}
    </>
  );
}
